/**
 * IP-based redirect for US visitors
 * Redirects visitors with US IP addresses to us.sophiebillebrahe.com
 */
(function () {
  "use strict";

  /**
   * Visitor IPs that must not be redirected to the US store (office, QA, partners, etc.).
   * Use the exact string returned by ipinfo/ipapi (IPv4 or IPv6).
   */
  const SKIP_REDIRECT_IPS = new Set([
    // Example: "203.0.113.50",
    "24.103.23.146"
  ]);

  function shouldSkipRedirectForIp(ip) {
    if (!ip || typeof ip !== "string") return false;
    return SKIP_REDIRECT_IPS.has(ip.trim());
  }

  // Check if already on US domain to avoid infinite redirects
  if (window.location.hostname === "us.sophiebillebrahe.com") {
    return;
  }

  // Cookie helper functions
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  function setCookie(name, value) {
    // Set session cookie (expires when browser closes)
    document.cookie = `${name}=${value}; path=/; SameSite=Lax`;
  }

  // Check if we've already determined the visitor is not from US
  // This prevents repeated API calls on subsequent page loads
  if (getCookie("ipRedirectChecked") === "nonUS") {
    return;
  }

  // Helper function to handle country check result
  function handleCountryCheck(countryCode, ip) {
    if (countryCode === "US") {
      if (shouldSkipRedirectForIp(ip)) {
        setCookie("ipRedirectChecked", "nonUS");
        return;
      }
      // Redirect US visitors to US domain
      const currentPath = window.location.pathname + window.location.search;
      window.location.href = "https://us.sophiebillebrahe.com" + currentPath;
    } else {
      // Set cookie to skip future checks for non-US visitors
      setCookie("ipRedirectChecked", "nonUS");
    }
  }

  // Try ipinfo.io first (requires token)
  const ipinfoToken = "85700463ae7cfd";
  fetch(`https://ipinfo.io/json?token=${ipinfoToken}`)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      if (data.country) {
        handleCountryCheck(data.country, data.ip);
      }
    })
    .catch((error) => {
      // Fallback to ipapi.co if ipinfo.io fails
      console.warn("ipinfo.io failed, trying ipapi.co:", error);
      fetch("https://ipapi.co/json/")
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          if (data.country_code) {
            handleCountryCheck(data.country_code, data.ip);
          }
        })
        .catch((fallbackError) => {
          // Silently fail if all API calls fail - don't block page load
          console.error("IP redirect check failed:", fallbackError);
        });
    });
})();
